import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserProgramRobotGame from 'src/games/ProgramRobotGame/Main';
import { message } from 'antd';

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(ProgramRobotGame)'
interface ProgramRobotGameProps extends RouteComponentProps<{}> {
    onComplete?: () => void;
}

interface ProgramRobotGameState {
}

class ProgramRobotGame extends React.Component<ProgramRobotGameProps, ProgramRobotGameState> {
    constructor(props: ProgramRobotGameProps) {
        super(props);
        bindAllOfThis(this, ProgramRobotGame.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    
    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserProgramRobotGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default ProgramRobotGame;



// WEBPACK FOOTER //
// ./src/pages/game/ProgramRobotGame.tsx